import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PlannerProjectService } from '@modules/planner/services/planner-project/planner-project.service';
import { UserService } from '@shared/services/user/user.service';
import { Subscription, switchMap, filter } from 'rxjs';
import { CustomerIds } from "@shared/models/customer-settings";

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    standalone: false
})
export class SideNavComponent implements OnInit, OnDestroy  {

  userType: number = parseInt(<string>localStorage.getItem('ROLE'));
  customerId: number | null = null;
  customerIds = CustomerIds;

  // Whether the Human Resources submenu is expanded
  humanResourcesOpen = false;

  // Routes that belong under the Human Resources submenu — used to keep it open
  // while navigating within the group and to close it when navigating elsewhere.
  private readonly humanResourcesRoutes = [
    'human-resources', 'workers', 'teams', 'worker-detail', 'teams-detail',
    'planner-management', 'planner-detail',
  ];

  private routerSub?: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private plannerContractorService: PlannerProjectService,
  ) { }

  // Submenu handling when the user is reloading the site / visiting the site from a link
  ngOnInit(): void {
    this.sideBarHandler()
    this.getCustomerId()

    // Recompute the submenu state on every navigation so that selecting another
    // top-level tab automatically closes an open submenu.
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.sideBarHandler())
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe()
  }

  getCustomerId() {
    this.userService.getUserInfo()
    .pipe(
      // Switch to the project observable using the current project ID from the user data.
      switchMap(userData => this.plannerContractorService.getProjectById(userData.current_project))
    )
    .subscribe({
      next: projectData => this.customerId = projectData.customer_id,
      error: error => console.error('Error fetching project data:', error)
    });
  }

  // Derives which submenu should be open from the currently active child route.
  // Keeps the Human Resources submenu open while navigating within its routes and
  // closes it automatically when another top-level tab is selected.
  sideBarHandler() {
    const path = this.activatedRoute.children[0]?.snapshot.url[0]?.path ?? '';
    this.humanResourcesOpen = this.humanResourcesRoutes.some(
      route => path === route || path.includes(route)
    );
  }

  toggleSubmenu(event: Event, submenuId: string) {
    event.preventDefault();
    if (submenuId === 'humanResourcesSubmenu') {
      this.humanResourcesOpen = !this.humanResourcesOpen;
    }
  }
}
